import React from 'react';
import { useEffect } from 'react';
import { FormGroup, Label, Input, Form, Row, Col } from 'reactstrap';
import { unregister } from "../Interceptor.js";
import { Alert } from 'reactstrap';
import AlertTitle from "@material-ui/lab/AlertTitle";

var dataMonedas = [{}];

var dataComprobantesTipo = [{ "Codigo": 34, "Descripcion": "Comprobante de Nomina" }, { "Codigo": 35, "Descripcion": "Comprobante de Ajuste de Nomina" }];

var numeroCompro = localStorage.getItem("NumeroComprobante");
var consecutivo= localStorage.getItem("consecutivoComprobante");
var monedaIn = localStorage.getItem("moneda");
var tasaCambioIn = localStorage.getItem("tasaCambio");

export default function General() {

    useEffect(() => {
        var fechaNow = new Date();
        formatDate(fechaNow);
        console.log(monedaIn);
        var h = fechaNow.getHours();
        var m = fechaNow.getMinutes();
        var hora = h + ":" + m;
        if (h < 10) {
            hora = "0" + h + ":" + m;
        } else {
            hora = h + ":" + m;
        }
        setHoraGeneracion(hora);
        console.log(hora);
        monedas();
        localStorage.setItem("tipoComprobante", 34);
    }, []);


    const formatDate = (date) => {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        var formatted = [year, month, day].join('-');
        setFechaGeneracion(formatted);
    }

    const [fechaGeneracion, setFechaGeneracion] = React.useState("");
    const [horaGeneracion, setHoraGeneracion] = React.useState("");
    const [numeroComprobante, setNumeroComprobante] = React.useState(numeroCompro);
    const [consecutivoComprobante, setconsecutivoComprobante] = React.useState(consecutivo);
    const [datamonedasList, setdatamonedasList] = React.useState(dataMonedas);
    const [moneda, setMoneda] = React.useState(monedaIn);
    const [tasacambio, settasacambio] = React.useState(tasaCambioIn);

    const handleFechaGeneracion = (e) => {
        console.log(e.target.value);
        localStorage.setItem("FechaGeneracion", e.target.value);
    }

    const handleHoraGeneracion = (e) => {
        console.log(e.target.value);
        localStorage.setItem("HoraGeneracion", e.target.value);
    }

    const handlenumeroComprobante = (e) => {
        console.log(e.target.value);
        setNumeroComprobante(e.target.value);
        localStorage.setItem("NumeroComprobante", e.target.value);
    }

    const handleconsecutivoComprobante = (e) => {
        console.log(e.target.value);
        setconsecutivoComprobante(e.target.value);
        localStorage.setItem("consecutivoComprobante", e.target.value);
    }
    const handlemoneda = (e) => {
        console.log(e.target.value);
        setMoneda(e.target.value);
        monedaIn = e.target.value;
        localStorage.setItem("moneda", e.target.value);
    }
    const handleTasaCambio = (e) => {
        console.log(e.target.value);
        settasacambio(e.target.value);
        localStorage.setItem("tasaCambio", e.target.value);
    }

    const handleTipo = (e) => {
        console.log(e.target.value);
        settasacambio(e.target.value);
        localStorage.setItem("tipoComprobante", e.target.value);
    }

    const monedas = () => {

        var myHeaders = new Headers();

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
        };

        const apiUrl = './api/Auxiliar/ListaMonedas';
        fetch(apiUrl, requestOptions)
            .then(response => response.json())
            .then(

                data => {
                    dataMonedas = data.basePresentationList;
                    console.log(data);
                    setdatamonedasList(dataMonedas);
                }

            )
            .catch(error => {
                console.log('error', error);

            }
            )
    }

    return (
        <React.Fragment>
            <h5 style={{ textAlign: "center", fontSize: "20px" }}>Comprobante de Nómina</h5>
            <Form>
                <Row>
                    <Col md="2">
                    </Col>
                    <Col md="1" style={{ borderRight: "6px solid #1d8cf8", height: "70px" }}>
                    </Col>
                    <Col md="6">
                        <FormGroup>
                            <Label for="exampleEmail" style={{ fontSize: "12px" }}>Tipo de comprobante</Label>
                            <Input type="select" name="select" id="exampleSelect" onChange={handleTipo} defaultValue={34} style={{ background: "#F7F7FF", border: "none", fontFamily: 'Hammersmith One' }}>
                                {dataComprobantesTipo.map((tipo, index) =>
                                    <option key={index} value={tipo.Codigo}>{tipo.Descripcion}</option>)}
                            </Input>
                        </FormGroup>
                    </Col>

                    <Col md="3">

                    </Col>
                </Row>

                <Row>
                    <Col md="2">
                    </Col>
                    <Col md="1">
                    </Col>
                    <Col md="6">
                        <Alert variant="filled" severity="warning" isOpen={true}>
                            <AlertTitle>Asignación de Consecutivo</AlertTitle>
                            El prefijo y el consecutivo será asignado de manera predeterminada, podrás asignar valores propios llenando los campos indicados abajo.
                                </Alert>
                    </Col>

                    <Col md="3">

                    </Col>
                </Row>

                <Row>
                    <Col md="2">
                    </Col>
                    <Col md="1" style={{ borderRight: "6px solid #1d8cf8", height: "90px" }}>
                    </Col>
                    <Col md="3">
                        <FormGroup >
                            <Label for="exampleEmail" style={{ fontSize: "12px" }}>Número de comprobante</Label>
                            <Input type="email" defaultValue={numeroComprobante} onChange={handlenumeroComprobante} name="email" id="exampleEmail" style={{ background: "#F7F7FF", border: "none", fontFamily: 'Hammersmith One' }} placeholder="000" />
                        </FormGroup>
                    </Col>
                    <Col md="3">
                        <FormGroup>
                            <Label for="exampleEmail" style={{ fontSize: "12px" }}>Consecutivo de comprobante</Label>
                            <Input type="email" defaultValue={consecutivoComprobante} onChange={handleconsecutivoComprobante} name="email" id="exampleEmail" style={{ background: "#F7F7FF", border: "none", fontFamily: 'Hammersmith One' }} placeholder="NOM" />
                        </FormGroup>
                    </Col>
                    <Col md="3">
                    </Col>
                </Row>
                <Row>
                    <Col md="2">
                    </Col>
                    <Col md="1" style={{ borderRight: "6px solid #1d8cf8", height: "90px" }}>
                    </Col>
                    <Col md="3">
                        <FormGroup>
                            <Label for="exampleEmail" style={{ fontSize: "12px" }}>Fecha de generación</Label>
                            <Input type="date" defaultValue={fechaGeneracion} onChange={handleFechaGeneracion} name="email" id="exampleEmail" style={{ background: "#F7F7FF", border: "none", fontFamily: 'Hammersmith One' }} disabled />
                        </FormGroup>
                    </Col>
                    <Col md="3">
                        <FormGroup>
                            <Label for="exampleEmail" style={{ fontSize: "12px" }}>Hora de generación</Label>
                            <Input type="time" defaultValue={horaGeneracion} onChange={handleHoraGeneracion} name="email" id="exampleEmail" style={{ background: "#F7F7FF", border: "none", fontFamily: 'Hammersmith One' }} disabled/>
                        </FormGroup>
                    </Col>
                    <Col md="3">
                    </Col>
                </Row>
                <Row>
                    <Col md="2">
                    </Col>
                    <Col md="1" style={{ borderRight: "6px solid #1d8cf8", height: "70px" }}>
                    </Col>
                    <Col md="3">
                        <FormGroup>
                            <Label for="exampleEmail" style={{ fontSize: "12px" }}>Moneda</Label>
                            <Input type="select" name="select" id="exampleSelect" onChange={handlemoneda} defaultValue={moneda} style={{ background: "#F7F7FF", border: "none", fontFamily: 'Hammersmith One' }}>
                                {datamonedasList.map((tipo, index) =>
                                    <option key={index} value={tipo.Codigo}>{tipo.Descripcion}</option>)}
                            </Input>
                        </FormGroup>
                    </Col>
                    <Col md="3">
                        <FormGroup>
                            <Label for="exampleEmail" style={{ fontSize: "12px" }} hidden={moneda == 1 || moneda == "COP" ? true : false}>Tasa de cambio TRM</Label>
                            <Input type="number" name="email" onChange={handleTasaCambio} defaultValue={tasacambio} id="exampleEmail" style={{ background: "#F7F7FF", border: "none", fontFamily: 'Hammersmith One' }} hidden={moneda == 1 || moneda == "COP" ? true : false} />
                        </FormGroup>
                    </Col>
                    <Col md="3">
                       
                    </Col>
                </Row>
                
            </Form >

        </React.Fragment>
    );
}